import { CLIENT_ID_CLOUD, PAGE_DOMAIN, PATH_ROOT } from 'constants/api'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { establishSession } from 'store/sessionSlice'
import { validateDomain } from 'utils/helpers'
import { useAuthFlow } from 'pages/authentication/AuthFlowContext'

const useLoginSSO = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { updateSSOFlow } = useAuthFlow()

    const loginSSOSuccess = (data, isProvideService) => {
        const { accessToken, refreshToken } = data
        dispatch(establishSession({ accessToken, refreshToken }));

        const domain = validateDomain(localStorage.getItem("redirectDomain"));

        if (domain) {
            window.location.href = domain;
            localStorage.removeItem("redirectDomain")
        } else {
            navigate(`${PATH_ROOT || '/'}${isProvideService ? '?provide-service=true' : ''}`);
        }
    }

    const loginSSOGoogle = () => {
        updateSSOFlow({
            info: {
                isProvideService: false,
                redirect_uri: `${PAGE_DOMAIN}iam/callback/google`,
            },
        })
        const params = new URLSearchParams({
            client_id: CLIENT_ID_CLOUD,
            redirect_uri: `${PAGE_DOMAIN}iam/callback/google`,
            response_type: "token",
            scope: "email profile",
            access_type: "online",
            prompt: "select_account",
        });
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
    }

    return {
        loginSSOSuccess,
        loginSSOGoogle
    }
}

export default useLoginSSO
